import {
    Table, TableBody, TableCell, TableHead, TableRow, Typography, Box
} from '@mui/material';
import React from 'react';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import { redColor } from 'config';

function ReportAuthorityListTable({ data }) {
    

    return (
        <>
            {Object.entries(data).map(([roleId, group]) => {
                // roleId 369 veya 372 ise Birim kolonu göster
                const showUnitColumn = roleId === "369" || roleId === "372";

                // Kolon genişliklerini belirle
                const columnWidths = showUnitColumn
                    ? ['40%', '30%', '30%']  // İsim, Kurum, Birim
                    : ['50%', '50%'];        // İsim, Kurum

                return (
                    <Box key={roleId}>
                        <h4 style={{
                            fontWeight: 'bold',
                            marginTop: 20,
                            marginBottom: 10,
                            color: redColor,
                            borderBottom: `2px solid ${redColor}`,
                            paddingBottom: 5
                        }}>
                            {group.roleName}
                        </h4>

                        <Table size="small" sx={{ marginBottom: 2, borderRadius: 3, lineHeight: 1 }}>
                            <TableHead sx={{ backgroundColor: "lightgrey" }}>
                                <TableRow>
                                    <TableCell
                                        align="left"
                                        sx={{
                                            width: columnWidths[0],
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        İsim
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        sx={{
                                            width: columnWidths[1],
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Kurum
                                    </TableCell>
                                    {showUnitColumn && (
                                        <TableCell
                                            align="left"
                                            sx={{
                                                width: columnWidths[2],
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Birim
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {group.members.map((member, index) => (
                                    <TableRow
                                        key={`${roleId}-${index}`}
                                        sx={{
                                            backgroundColor: '#fafafa',
                                            '&:hover': { backgroundColor: '#f0f0f0' }
                                        }}
                                    >
                                        <TableCell
                                            align="left"
                                            sx={{
                                                width: columnWidths[0]
                                            }}
                                        >
                                            {member.name} {member.surname}
                                        </TableCell>
                                        <TableCell
                                            align="left"
                                            sx={{
                                                width: columnWidths[1]
                                            }}
                                        >
                                            {member.inst}
                                        </TableCell>
                                        {showUnitColumn && (
                                            <TableCell
                                                align="left"
                                                sx={{
                                                    width: columnWidths[2]
                                                }}
                                            >
                                                {member.unitName}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                );
            })}
        </>
    );
}

export default ReportAuthorityListTable; 